<template>
  <div id="register">
    <mu-container>
      <mu-paper class="register_paper" :z-depth="2">
        <mu-row>
          <mu-col :span="6">
            <mu-flex class="left_block" direction="column">
              <mu-flex align-items="center" class="logo">
                <img src="@/assets/image/logo_mini.png" class="logo" />
                <span>iVYAi MPDM</span>
              </mu-flex>
              <lottie :options="defaultOptions" class="loadding" />
            </mu-flex>
          </mu-col>
          <mu-col :span="6">
            <mu-flex class="right_block" direction="column">
              <mu-flex align-items="center" justify-content="center" style="width:100%;">
                <mu-stepper :active-step="activeStep" style="width:100%;">
                  <mu-step>
                    <mu-step-label>{{$t('register.writeMes')}}</mu-step-label>
                  </mu-step>
                  <mu-step>
                    <mu-step-label>{{$t('register.ruleMail')}}</mu-step-label>
                  </mu-step>
                  <mu-step>
                    <mu-step-label>{{$t('register.improveInformation')}}</mu-step-label>
                  </mu-step>
                  <mu-step>
                    <mu-step-label>{{$t('register.registerSuccess')}}</mu-step-label>
                  </mu-step>
                </mu-stepper>
              </mu-flex>
              <mu-flex v-if="activeStep == 0" direction="column" style="width:100%;">
                <mu-form
                  ref="registerForm"
                  :model="registerForm"
                  class="register_form"
                  label-position="right"
                  label-width="80"
                >
                  <mu-form-item
                    :label="$t('register.name')"
                    prop="companyName"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                  >
                    <mu-text-field v-model="registerForm.companyName"></mu-text-field>
                  </mu-form-item>
                  <mu-form-item
                    :label="$t('register.contract')"
                    prop="contract"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                  >
                    <mu-text-field v-model="registerForm.contract"></mu-text-field>
                  </mu-form-item>
                  <!-- <mu-form-item
                    :label="$t('register.mobile')"
                    prop="mobile"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require(), $znValidate.phoneNumber()] : [$enValidate.require(), $enValidate.phoneNumber()]"
                  >
                    <mu-text-field v-model="registerForm.mobile" prop="mobile"></mu-text-field>
                  </mu-form-item> -->
                   <mu-form-item
                    :label="$t('register.mobile')"
                    prop="mobile"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require(), $znValidate.phoneNumber()] : ''"
                  >
                    <mu-text-field v-model="registerForm.mobile" prop="mobile"></mu-text-field>
                  </mu-form-item>
                  <mu-form-item
                    :label="$t('register.email')"
                    prop="email"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require(), $znValidate.email()] : [$enValidate.require(), $enValidate.email()]"
                  >
                    <mu-text-field v-model="registerForm.email" prop="email"></mu-text-field>
                  </mu-form-item>
                  <!-- <mu-form-item label="验证码" prop="password">
                                    <mu-text-field type="password" v-model="registerForm.password" prop="password"></mu-text-field>
                  </mu-form-item>-->
                  <Captcha :resultCallBack="(p)=>{registerForm.validate = p}" />
                  <mu-button
                    color="primary"
                    @click="sendMail"
                    full-width
                    round
                    style="margin-top:24px;"
                    v-loading="registerLoading"
                  >{{$t('register.register')}}</mu-button>
                  <mu-flex justify-content="center">
                    <mu-button
                      color="primary"
                      flat
                      @click="back"
                      full-width
                      style="margin-top:16px;"
                    >{{$t('register.back')}}</mu-button>
                  </mu-flex>
                </mu-form>
              </mu-flex>
              <mu-flex
                v-if="activeStep == 1"
                direction="column"
                style="width:100%;margin:16px 0px;"
              >
                <mu-alert color="deepPurple300">
                  <mu-flex direction="column">
                    {{$t('register.sendEmail')}}
                    <mu-chip style="margin-top:32px;" color="deepPurple300">
                      <mu-avatar :size="28">
                        <mu-icon value="mail"></mu-icon>
                      </mu-avatar>
                      {{registerForm.email}}
                    </mu-chip>
                  </mu-flex>
                </mu-alert>
                <mu-flex class="mail_tip" direction="column">
                  <p>{{$t('register.msg_1')}}</p>
                  <span>{{$t('register.msg_2')}}</span>
                  <span>
                    {{$t('register.msg_3')}}
                    <mu-button
                      flat
                      samll
                      color="primary"
                      @click="reSendMail"
                    >{{$t('register.sendAgain')}}</mu-button>
                  </span>
                  <span>
                    {{$t('register.msg_4')}}
                    <mu-button
                      flat
                      samll
                      color="primary"
                      @click="activeStep = 0"
                    >{{$t('button.edit')}}</mu-button>
                  </span>
                </mu-flex>
                <mu-flex justify-content="center" style="margin-top:48px;width:100%;">
                  <mu-button
                    color="primary"
                    flat
                    @click="back"
                    style="margin-right:16px;"
                  >{{$t('register.back')}}</mu-button>
                  <!-- <mu-button color="primary" @click="goMailAddress" round>{{$t('button.toCheck')}}</mu-button> -->
                </mu-flex>
              </mu-flex>
              <mu-flex v-if="activeStep == 2" direction="column" style="width:100%;">
                <mu-form
                  ref="customerForm"
                  :model="customerForm"
                  class="register_form"
                  style="margin:16px 0px;"
                >
                  <mu-row gutter>
                    <mu-col :span="6">
                      <mu-form-item
                        :label="$t('register.password')"
                        prop="password"
                        :rules="passwordRules"
                      >
                        <mu-text-field v-model="customerForm.password" type="password"></mu-text-field>
                      </mu-form-item>
                    </mu-col>
                    <mu-col :span="6">
                      <mu-form-item
                        :label="$t('register.repeatPwd')"
                        prop="repeatPwd"
                        :rules="repeatPasswordRules"
                      >
                        <mu-text-field v-model="customerForm.repeatPwd" type="password"></mu-text-field>
                      </mu-form-item>
                    </mu-col>
                  </mu-row>
                  <mu-row gutter>
                    <mu-col :span="6">
                      <mu-form-item
                        :label="$t('register.mobile')"
                        prop="mobile"
                        :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require(), $znValidate.phoneNumber()] : [$enValidate.require()]"
                      >
                        <mu-text-field v-model="customerForm.mobile"></mu-text-field>
                      </mu-form-item>
                    </mu-col>
                    <mu-col :span="6">
                      <mu-form-item
                        :label="$t('register.industry')"
                        prop="industry"
                        :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                      >
                        <mu-text-field
                          v-model="customerForm.industry"
                          readonly
                          :action-icon="'search'"
                          :action-click="() => openIndustrySelect()"
                          @click="openIndustrySelect"
                        ></mu-text-field>
                      </mu-form-item>
                    </mu-col>
                  </mu-row>
                  <mu-row gutter>
                    <mu-col :span="12">
                      <mu-form-item
                        :label="$t('register.orderId')"
                        :help-text="$t('index.optional')"
                        prop="orderId"
                      >
                        <mu-text-field v-model="customerForm.orderId"></mu-text-field>
                      </mu-form-item>
                    </mu-col>
                  </mu-row>
                  <mu-form-item
                    :label="$t('register.area')"
                    prop="area"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                     v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'"
                  >
                    <mu-text-field
                      v-model="addressDisplay"
                      readonly
                      :action-icon="'pin_drop'"
                      :action-click="() => openAddressSelect()"
                      @click="openAddressSelect"
                    ></mu-text-field>

                  </mu-form-item>

                  <mu-form-item
                    :label="$t('register.area')"
                    prop="country"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                     v-else
                  >

                     <mu-text-field
                      v-model="addressDisplay"
                      readonly
                      :action-icon="'pin_drop'"
                      :action-click="() => openAddressSelect()"
                      @click="openAddressSelect"
                    ></mu-text-field>
                  </mu-form-item>


                  <mu-form-item
                    :label="$t('register.address')"
                    prop="address"
                    :rules="$store.state.lang =='zh' || $store.state.lang =='zh-CN' ? [$znValidate.require()] : [$enValidate.require()]"
                  >
                    <mu-text-field v-model="customerForm.address"></mu-text-field>
                  </mu-form-item>
                  <Captcha :resultCallBack="(p)=>{customerForm.validate = p}" />
                  <mu-button
                    color="primary"
                    @click="retgister"
                    full-width
                    round
                    style="margin-top:16px;"
                  >{{$t('button.submit')}}</mu-button>
                </mu-form>
              </mu-flex>
              <mu-flex v-if="activeStep == 3" direction="column" style="width:100%;">
                <mu-flex
                  align-items="center"
                  direction="column"
                  fill
                  style="width:100%;margin-top:48px;"
                >
                  <lottie :options="successOption" style="width:180px;height:180px;" />
                  <h5 class="success_tip">{{$t('register.msg_5')}}</h5>
                </mu-flex>
                <mu-flex justify-content="center" style="margin-top:48px;width:100%;">
                  <mu-button
                    color="primary"
                    flat
                    @click="back"
                    style="margin-right:16px;"
                  >{{$t('register.back')}}</mu-button>
                </mu-flex>
              </mu-flex>
            </mu-flex>
          </mu-col>
        </mu-row>
      </mu-paper>
    </mu-container>
    <BottomSheetSelect
      ref="industryBottomSheet"
      :title="$t('register.choiceIndustry')"
      :selectArray="industryData.zh"
      displayProp="name"
      :selectDone="selectIndustry"
      :selectType="1"
      v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'"
    />
    <BottomSheetSelect
      ref="industryBottomSheet"
      :title="$t('register.choiceIndustry')"
      :selectArray="industryData.en"
      displayProp="name"
      :selectDone="selectIndustry"
      :selectType="1"
      v-else
    />
    <AddressSelect
      ref="addressSelect"
      :title="$t('register.choiceAddress')"
      :selectDone="selectAddress"
      :layer="3"
      v-if="$store.state.lang =='zh' || $store.state.lang =='zh-CN'"
    />
    <Country
      ref="countrySelect"
      :title="$t('register.choiceAddress')"
      :selectArray="countryData.en"
      displayProp="name"
      :selectDone="selectCountry"
       v-if="$store.state.lang =='en'"
       :selectType="1"
    />
  </div>
</template>
<script>
import * as animationData from "../assets/lottie/registration_animation.json";
import * as successLottie from "../assets/lottie/success_animation.json";
import industryData from "../assets/js/industry";
import countryData from "../assets/js/country";
import store from "@/vuex/store";
import Captcha from "@/components/Captcha";
import BottomSheetSelect from "@/components/BottomSheetSelect";
import AddressSelect from "@/components/AddressSelect";
import Country from "@/components/Country";
import * as API from "@/api/system/register";

export default {
  name: "register",
  data() {
    return {
      activeStep: 0,
      registerForm: {
        companyName: "",
        contact: "",
        mobile: "",
        email: "",
        validate: false
      },
      customerForm: {},
      registerLoading: false,
      submitLoading: false,
      defaultOptions: {
        animationData: animationData,
        loop: false
      },
      successOption: {
        animationData: successLottie,
        loop: false
      },
      industryData: industryData,
      countryData:countryData,
      addressDisplay: "",
      repeatPasswordRules: [
        { validate: val => !!val, message: this.$t("register.mgs_rule_pass_required") },
        {
          validate: val => val.length >= 3 && val.length <= 10,
          message: this.$t("register.mgs_rule_passlength")
        },
        {
          validate: val => val == this.customerForm.password,
          message: this.$t("register.msg_rule_secondPass")
        }
      ],
      passwordRules: [
        { validate: val => !!val, message: this.$t("register.mgs_rule_pass_required") },
        {
          validate: val => val.length >= 3 && val.length <= 10,
          message: this.$t("register.mgs_rule_passlength")
        },
      ],
    };
  },
  components: { Captcha, BottomSheetSelect, AddressSelect, Country },
  mounted() {
    if (
      this.$route.query &&
      this.$route.query.id &&
      this.$route.query.from &&
      this.$route.query.from == "mailAuth"
    ) {
      this.activeStep = 2;
      API.mailApplyInfo({ id: this.$route.query.id })
        .then(res => {

          if (res.code == 200) {
            this.customerForm = res.data;
            if (this.customerForm.province) {
              this.addressDisplay = this.customerForm.province;
            }
            if (this.customerForm.city) {
              this.addressDisplay += " / " + this.customerForm.city;
            }
            if (this.customerForm.area) {
              this.addressDisplay += " / " + this.customerForm.area;
            }
          } else {
            this.$alert(res.message, this.$t("common.tips"), {
              okLabel: this.$t("register.msg_8")
            }).then(() => {
              this.$router.replace("/");
            });
          }
        })
        .catch(res => {
          this.$alert(this.$t("register.msg_9"), this.$t("common.tips"), {
            okLabel: this.$t("register.msg_8"),
            type: "error"
          }).then(() => {
            this.$router.replace("/");
          });
        });
    }
  },
  methods: {
    sendMail() {
      this.$refs.registerForm.validate().then(result => {

        if (!result) {
          return;
        }
        if (!this.registerForm.validate) {
          this.$toast.error(this.$t("register.msg_6"));
          return;
        }
        this.registerLoading = true;
        API.applyMail(this.registerForm).then(res => {
          if (res.code == 200) {
            this.registerForm = res.data;
            this.activeStep++;
          } else {
            this.$toast.error(res.message);
          }
          this.registerLoading = false;
        });
      });
    },
    reSendMail() {
      API.resendMail(this.registerForm).then(res => {
        if (res.code == 200) {
          this.$toast.success(this.$t("register.msg_7"));
        } else {
          this.$toast.error(res.message);
        }
      });
    },
    goMailAddress() {
      var index = this.registerForm.email.lastIndexOf("@");
      var mailUrl = this.registerForm.email.substring(
        index + 1,
        this.registerForm.email.length
      );
      window.open("http://mail." + mailUrl);
    },
    openIndustrySelect() {
      this.$refs.industryBottomSheet.openSelector();
    },
    selectIndustry(selectItem) {
      this.customerForm.industry = selectItem.name;
      this.$forceUpdate();
    },
    openAddressSelect() {
      if(store.state.lang =='zh' || store.state.lang =='zh-CN')
         {
             this.$refs.addressSelect.openSelector();
         } else{
            this.$nextTick(() =>{
                this.$refs.countrySelect.openSelector();
            })

         }
    },
    selectCountry(selectItem){
         this.addressDisplay  = selectItem.name;
         this.customerForm.country = selectItem.name;
    },
    selectAddress(addressObj) {

      this.addressDisplay =
        addressObj.province.name +
        " / " +
        addressObj.city.name +
        " / " +
        addressObj.area.name;

      this.customerForm.province = addressObj.province.name;
      this.customerForm.city = addressObj.city.name;
      this.customerForm.area = addressObj.area.name;
    },
    retgister() {
      this.$refs.customerForm.validate().then(result => {

        if (!result) {
          return;
        }
        if (!this.customerForm.validate) {
          this.$toast.error(this.$t("register.msg_6"));
          return;
        }
        this.submitLoading = true;
        API.finishRegister(this.customerForm).then(res => {
          if (res.code == 200) {
            this.customerForm = res.data;
            this.activeStep++;
          } else {
            this.$toast.error(res.message);
          }
          this.submitLoading = false;
        });
      });
    },
    back() {
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
@import "../assets/css/slideBlock.css";

#register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.register_paper {
  background-color: #ffffff;
  box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
    0 16px 24px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}
.left_block {
  height: 76vh;
  background: #4880ff;
  background: linear-gradient(
    311deg,
    rgba(115, 109, 255, 1) 0%,
    rgba(169, 127, 255, 1) 100%
  );
  box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
    0 16px 24px 2px rgba(0, 0, 0, 0.05);
  padding: 24px 36px;
}
.left_block .logo img {
  width: 32px;
  height: auto;
  margin-right: 8px;
}
.left_block .logo span {
  font-size: 24px;
  color: #ffffff;
  font-weight: 600;
  font-family: "DINCOND";
}
.right_block {
  height: 76vh;
  padding: 16px 48px;
  overflow: auto;
}
.right_block .register_form {
  width: 100%;
  margin: 48px 0px;
}
.right_block .mail_tip {
  margin-top: 24px;
  width: 100%;
}
.right_block .mail_tip p {
  color: #4e5a63;
  font-weight: 500;
}
.right_block .mail_tip span {
  margin: 8px 0px;
  color: #4e5a63;
  font-size: 12px;
  font-weight: 400;
}
.right_block .success_tip {
  color: #20253a;
  line-height: 28px;
  font-size: 14px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue